export enum SizeLink {
    S = 'small',
    M = 'medium',
}

export enum TypeLink {
    INTERNAL = 'internal',
    INTERNAL_WITH_ICON = 'internalWithIcon',
    EXTERNAL = 'external',
}
